'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CatalogNumericConstants = exports.CatalogConstants = undefined;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CatalogConstants = exports.CatalogConstants = (0, _keymirror2.default)({
    LOAD_HAS_OFFERS_IN_ROOT: null,
    LOAD_HAS_OFFERS_IN_ROOT_SUCCESS: null,
    LOAD_HAS_OFFERS_IN_ROOT_FAIL: null,

    LOAD: null,
    LOAD_SUCCESS: null,
    LOAD_FAIL: null,

    LOAD_DETAIL: null,
    LOAD_DETAIL_SUCCESS: null,
    LOAD_DETAIL_FAIL: null,

    LOAD_CATALOG: null,
    LOAD_CATALOG_FAIL: null,
    LOAD_CATALOG_SUCCESS: null,

    LOAD_CATEGORIES: null,
    LOAD_CATEGORIES_SUCCESS: null,
    LOAD_CATEGORIES_FAIL: null,

    LOAD_PRODUCT_BY_CATEGORIES: null,
    LOAD_PRODUCT_BY_CATEGORIES_SUCCESS: null,
    LOAD_PRODUCT_BY_CATEGORIES_FAIL: null,

    LOAD_BY_CATEGORIES: null,
    LOAD_BY_CATEGORIES_SUCCESS: null,
    LOAD_BY_CATEGORIES_FAIL: null,

    CATEGORY_RECOMENDED_LOAD: null,
    CATEGORY_RECOMENDED_LOAD_SUCCESS: null,
    CATEGORY_RECOMENDED_LOAD_FAIL: null,

    SEARCH_PRODUCTS_LOAD: null,
    SEARCH_PRODUCTS_LOAD_SUCCESS: null,
    SEARCH_PRODUCTS_LOAD_FAIL: null,

    SEARCH_PRODUCTS_RESET: null,
    SET_SEARCH_CLOSE: null,

    LOAD_LAST_CATALOG_UPDATE_DATE: null,
    LOAD_LAST_CATALOG_UPDATE_DATE_SUCCESS: null,
    LOAD_LAST_CATALOG_UPDATE_DATE_FAIL: null,

    REFRESH_CATALOG_LOAD: null,
    REFRESH_CATALOG_LOAD_SUCCESS: null,
    REFRESH_CATALOG_LOAD_FAIL: null
});

var CatalogNumericConstants = exports.CatalogNumericConstants = {
    CATEGORY_PAGE_LIMIT: 12,
    MAX_LIMIT: 999999,
    MAX_PAGE: 999999,
    SEARCH_PAGE_LIMIT: 12
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/constants/catalog.js
// module id = 1867
// module chunks = 0